import { render, staticRenderFns } from "./MarketingPermissions.vue?vue&type=template&id=fa94d7ec&"
import script from "./MarketingPermissions.vue?vue&type=script&lang=js&"
export * from "./MarketingPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports